<template>
  <v-card class="rounded-lg">
    <div>
      <v-img
        contain
        class="white--text align-end"
        height="200px"
        :src="item.cover ? item.cover : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/bg-success.jpg'"
      ></v-img>
    </div>
    <v-card-title class="blue--text" style="word-break: break-word">
      {{ title }} <v-spacer></v-spacer><m-menu right class="clearfix" style="float: right" :items="actions" :object="item" />
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <p class="py-0 orange--text font-weight-bold">Syarat Jenis Kelas:</p>
      <div v-if="syarats.length > 0">
        <v-row class="mx-1 black--text" v-for="(itemSyarat, index) in syarats" :key="index">
          <v-col class="my-0 py-1 px-0 caption" cols="10">
            <div v-for="(info, i) in itemSyarat.syarat.hasil" :key="i">
              <span class="mr-1"><span class="font-weight-medium"> </span>{{ info.keterangan.text[0] }}:</span>
              <!--              <span class="font-weight-bold" v-for="(value, index) in info.keterangan.include" :key="value.index">-->
              <!--                {{ value }}-->
              <!--                <span v-if="index !== info.keterangan.include.length - 1 && info.keterangan.include.length !== 1">/</span>-->
              <!--              </span>-->
              <span class="font-weight-bold" v-for="(value, index) in info.keterangan.include" :key="value.index">
                {{ value }}
                <span v-if="index !== info.keterangan.include.length - 1 && info.keterangan.include.length !== 1">/</span>
              </span>

              <span v-if="itemSyarat.syarat.hasil && itemSyarat.syarat.hasil.length > 1 && i != itemSyarat.syarat.hasil.length - 1" class="grey--text">&nbsp;atau</span>
            </div>
          </v-col>
          <v-col class="mb-0 py-2 px-0" cols="2">
            <!-- <m-button x-small fab color="warning" icon="mdi-pencil" action="syarat" @syarat="syarat(item, true)"></m-button> &nbsp; -->
            &nbsp;
            <m-button id="hapus" x-small fab color="error" icon="mdi-delete" action="hapus" @hapus="hapus(itemSyarat)"></m-button>
          </v-col>
        </v-row>
      </div>
      <span class="error--text caption" v-if="syarats.length == 0">- Syarat belum ditambahkan</span>
    </v-card-text>
    <v-card-actions class="grey lighten-3">
      <v-spacer></v-spacer>
      <m-button
        id="tambah-syarat"
        class="btn-aksi white--text ma-1"
        color="orange darken-2"
        icon="mdi-plus"
        textButton="Syarat"
        action="syarat"
        @syarat="syarat(item, false)"
      ></m-button>
    </v-card-actions>
  </v-card>
</template>

<script>
import MButton from "./MButton.vue";

// @group Global Component
export default {
  inheritAttrs: false,
  data() {
    return {
      panel: [0],
      syarats: []
    };
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "primary"
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  components: { MButton },
  mounted() {
    this.getSyarat();
  },
  methods: {
    syarat(item, isEdit) {
      this.item.isEdit = isEdit;
      this.$emit("syarat", item);
    },
    getSyarat() {
      return this.$store
        .dispatch("jenisKelas/getSyaratApplied", { instansi_id: this.instansi_id, jenis_kelas_id: this.item.id })
        .then(res => {
          this.syarats = res;
        })
        .catch(e => e);
    },
    hapus(item) {
      let n_syarat = item.syarat.hasil[0].nama_syarat;
      this.$confirm(
        `Apakah Anda yakin akan menghapus jenis syarat ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.syarat.hasil[0].nama_syarat}<br>
        </div>`
      )
        .then(() =>
          this.$store.dispatch("jenisKelas/dropSyarat", {
            item: item.syarat,
            instansi_id: this.instansi_id,
            syarat_url: n_syarat.replace(/[\s+_]/g, "-").toLowerCase()
          })
        )
        .then(() => {
          this.$info("Jenis Syarat " + item.syarat.nama_syarat + " berhasil dihapus");
        })
        .then(() => this.getSyarat())
        .catch(e => e);
    }
  },
  watch: {
    item(n) {
      this.getSyarat(n);
    }
  }
};
</script>

<style scoped>
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
